import { ActionTypes } from "../actions";
const ComponentIcon = {
  Billing: "billing",
  Bolt: "bolt",
  Button: "button",
  Carousel: "carousel",
  Chats: "chats",
  Code: "code",
  Countdown: "countdown",
  Cube: "cube",
  Database: "database",
  Divider: "divider",
  Form: "form",
  Gallery: "gallery",
  Help: "help",
  Image: "image",
  Layout: "layout",
  Lock: "lock",
  Navigation: "navigation",
  SocialLinks: "social-links",
  Star: "star",
  Text: "text",
  Users: "users",
  Video: "video"
};
function getInitialState({
  componentsMeta = /* @__PURE__ */ new Map()
} = {}) {
  return componentsMeta;
}
function getComponentsMeta(state) {
  return state;
}
function reducer(state = getInitialState(), action) {
  switch (action.type) {
    case ActionTypes.REGISTER_COMPONENT:
      return new Map(state).set(action.payload.type, action.payload.meta);
    case ActionTypes.UNREGISTER_COMPONENT: {
      const nextState = new Map(state);
      const deleted = nextState.delete(action.payload.type);
      return deleted ? nextState : state;
    }
    default:
      return state;
  }
}
export {
  ComponentIcon,
  getComponentsMeta,
  getInitialState,
  reducer
};
//# sourceMappingURL=components-meta.js.map